import { TaskManagementService } from './../../../../task/services/task-management.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type EditAuthorDialogData = {
    leaveId: number;
    actuationId: number;
    authorFormGroup: UntypedFormGroup;
    tipo: string;
};


@Component({
    selector: 'app-edit-author-dialog',
    templateUrl: './edit-author-dialog.component.html',
    styleUrls: ['./edit-author-dialog.component.scss'],
    standalone: false
})
export class EditAuthorDialogComponent implements OnInit {

    responsibleAuthorTypes:string;
    responsibleModuleName:string;
    isShowAutor;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: EditAuthorDialogData,
        private dialog: MatDialogRef<EditAuthorDialogComponent>,
        public taskManagementService: TaskManagementService
    ) { 
        this.taskManagementService.initTaskForm(1);
    }


    ngOnInit(): void {
        console.log(this.data.tipo)
        this.responsibleAuthorTypes="GMCEU";
        this.responsibleModuleName="author-dialog";
        this.isShowAutor=true;
        // clear author form
        //this.data.authorFormGroup.reset();
        // remove all validators
        this.clearValidators();
        // set author type as required
        this.data.authorFormGroup.get('Tipo').setValidators(Validators.required);
        this.data.authorFormGroup.updateValueAndValidity();
    }


    public confirmUpdate() {
        // validate
        this.data.authorFormGroup.markAllAsTouched();
        if (this.data.authorFormGroup.valid)
            this.dialog.close(true);
    }


    public declineUpdate() {
        // clear author form
        this.data.authorFormGroup.reset();
        // remove all validators
        this.clearValidators();

        this.dialog.close(false);
    }


    /**
     * Clear all validators from the form
     */
    private clearValidators() {
        // loop through all form controls
        for (const control in this.data.authorFormGroup.controls) {
            if (this.data.authorFormGroup.controls.hasOwnProperty(control)) {
                this.data.authorFormGroup.controls[control].clearValidators();
                this.data.authorFormGroup.controls[control].updateValueAndValidity();
            }
        }
    }

}
